import { Attribute, Headline, Image, Caption, SubHeader } from "../../subcomponents/subcomponents";
import Styles from "./view_project.module.css";
export const Project = ( props ) => {
    const { project, project : { name, nameTheme, members, state, stateTheme, image, imageTheme, teamTitle, teamTitleIcon, teamSection, date, sections, captionTheme, captionColor } = {} } = props;
    const { Project } = Styles;
    return (
        <div className={ Project }>
            {/*========Info Section========*/}
            { project && <InfoSection 
                members       = { members       }
                state         = { state         }
                stateTheme    = { stateTheme    }
                image         = { image         }
                imageTheme    = { imageTheme    }
                name          = { name          }
                nameTheme     = { nameTheme     }
                teamTitle     = { teamTitle     }
                teamTitleIcon = { teamTitleIcon }
                teamSection   = { teamSection   }
            />}
            {/*==========Caption===========*/}
            { sections && <Caption
                date     = { date         }
                sections = { sections     }
                theme    = { captionTheme }
                color    = { captionColor }
            />}
        </div>
    );
};
const InfoSection = ( props ) => {
    const { members, state, stateTheme, image, imageTheme, name, nameTheme, teamTitle, teamTitleIcon, teamSection  } = props;
    const { InfoSection } = Styles;
    const Attributes = [
        { 
            icon  : <i className="bi bi-people-fill"></i>, 
            span  : <span></span>, 
            text  : members 
        },
        { 
            icon  : <i className="bi bi-bar-chart-fill" style={{ color: stateTheme }}></i>, 
            span  : <span style={{ backgroundColor: stateTheme }}></span>, 
            text  : state, 
            color : stateTheme 
        }
    ];
    
    return (
        <div className={ InfoSection }>
            {/*========Project Image========*/}
            { image && <Image 
                src   = { image      }
                theme = { imageTheme }
            />}
            {/*======Project Attributes=====*/}
            { Attributes && <Attribute
                Attributes = { Attributes }
                width      = { 400        }
            />}
            {/*========Project Title========*/}
            { name && <Headline
                icon  = { <i className="bi bi-feather"></i> }
                text  = { name                              }
                width = { 400                               }
                theme = { nameTheme                         }
            />}
            {/*========Project Team========-*/}
            { teamSection && <TeamSection
                teamTitle     = { teamTitle     }
                teamTitleIcon = { teamTitleIcon }
                team          = { teamSection   }
            />}
        </div>
    );
};
const TeamSection = ( props ) => {
    const { teamTitle, teamTitleIcon, team = [] } = props;
    const { TeamSection } = Styles;
    return (
        <div className={ TeamSection }>
            <SubHeader
                icon = { teamTitleIcon }
                text = { teamTitle     }
            />
            { 
                team.map(( value, key) => {
                    const { name, icon, theme, link } = value;
                    return (
                        <Headline
                            icon  = { icon  }
                            text  = { name  }
                            width = { 400   }
                            theme = { theme }
                            link  = { link  }
                            key   = { key   }
                        />
                    );
                })
            }
        </div>
    );
};